import { RevisionObjStatus } from './RevisionObjStatus';
import RevisionCommentModel from './RevisionCommentModel';
import SubscriptionBaseModel from './SubscriptionBaseModel';
import CustomLawRevisionModel from './CustomLawRevisionModel';
import RevisionMediaAttachmentModel from './RevisionMediaAttachmentModel';
import RevisionQuestion from './RevisionQuestion';

interface RevisionSubscriptionModel extends SubscriptionBaseModel {
    revisionStatus: RevisionObjStatus;
    comments: RevisionCommentModel[];
    mediaAttachments: RevisionMediaAttachmentModel[];
    lawTemplateText: string;
    customRevisionQuestions: RevisionQuestion[];
}

export const isRevisionSubscription = (obj: RevisionSubscriptionModel | CustomLawRevisionModel | any): obj is RevisionSubscriptionModel => {
    return (obj as RevisionSubscriptionModel).subscriptionId !== undefined;
};

export default RevisionSubscriptionModel;
